import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  LabelList,
  ResponsiveContainer,
  Cell
} from "recharts";
import { Card, Badge } from "react-bootstrap";

function CityBarChart() {
  const [citiesData, setCitiesData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("./dati_dashboard.json");
        const data = await response.json();

        const transformedData = Object.keys(data.TP.paesi).map((key) => {
          const countryData = data.TP.paesi[key];
          const totalValore = countryData.reduce((acc, curr) => acc + parseFloat(curr.valore), 0);
          const totalNumero = countryData.reduce((acc, curr) => acc + parseInt(curr.numero), 0);

          return {
            nazione: key, // Ripristinato il nome originale CON gli spazi
            valore: totalValore,
            numero: totalNumero,
          };
        });

        transformedData.sort((a, b) => b.valore - a.valore);
        setCitiesData(transformedData.slice(0, 5));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

 const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);

  return (
    <Card className="card ombra card-week card-home hover-effect border-0 tp-chart-card" style={{ borderRadius: '15px', padding: '1rem' }}>
      <div className="d-flex justify-content-between align-items-center px-3 tp-chart-header">
        <div>
          <h6 className="text-title fw-bold mb-0" style={{ letterSpacing: '1px' }}>ORDINI PER NAZIONE</h6>
          <small className="text-muted" style={{ fontSize: '0.65rem' }}>Totale vendite internazionali</small>
        </div>
<Badge
  pill
  className="tp-badge-red"
  style={{ fontSize: "0.6rem", padding: "5px 10px" }}
>
  GLOBAL
</Badge>      </div>

      <div className="tp-chart-body">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={citiesData}
            layout="vertical"
            // Aumentato il margine sinistro a 100 per ospitare i nomi interi
            margin={{ top: 10, right: 10, left: 0, bottom: 10 }}
            barCategoryGap="20%"
          >
            <XAxis type="number" hide />
            
            {/* YAxis riattivato e configurato per mostrare i nomi a sinistra */}
            <YAxis 
              dataKey="nazione" 
              type="category" 
              axisLine={false}
              tickLine={false}
              tick={{ 
                fill: '#212529', 
                fontSize: "0.75rem", 
                fontWeight: "bold", 
                textTransform: "uppercase" 
              }}
              // Larghezza fissa per l'area del testo
              width={100} 
            />

            <Tooltip
              cursor={{ fill: 'transparent' }}
              contentStyle={{
                borderRadius: '10px',
                border: 'none',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                fontSize: '12px'
              }}
              formatter={(value) => [formatToEuro(value), "Fatturato"]}
            />

            <Bar
              dataKey="valore"
              radius={[0, 10, 10, 0]}
              barSize={32}
            >
              {citiesData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={index === 0 ? "#b81f25" : "#5a5a5a"} />
              ))}

              {/* VALORE EURO: A destra, fuori dalla barra */}
              <LabelList
                dataKey="valore"
                position="right"
                offset={10}
                formatter={(value) => formatToEuro(value)}
                fill="#b81f25"
                style={{ fontSize: "0.75rem", fontWeight: "900" }}
              />

             
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}

export default CityBarChart;